import {
    ADD_NEW_FIELDS,
    CHANGE_FIELD,
    CHANGE_FIELD_PROPERTY,
    CHANGE_FIELD_VALUE,
    DELETE_FORM,
    REMOVE_FIELD,
    REPLACE_FORM_FIELDS,
    REMOVE_FIELD_ERROR,
    SCROLL_TO_FIELD,
    SET_FIELD_ERROR,
    SET_FIELD_VISIBLE,
    SET_NEW_FIELDS,
    SET_NEW_FORM,
    UPDATE_FIELD_VALUES,
    UPDATE_FIELDS,
    UPDATE_FORM_PROPERTY,
} from 'apps/auth/actions/formAction';
import { CHANGE_STATE } from 'apps/auth/actions/loginAction';
import { CAPTCHA, J_CAPTCHA, J_PASSWORD, J_USERNAME, PASSWORD, PHONE } from 'apps/auth/constants/Constants';
import update from 'apps/auth/helpers/Immutability';
import { isObject } from 'apps/auth/helpers/utils';

const clearFieldNameForLoginPage = (fieldName) => {
    let clearName = fieldName;
    if (fieldName === J_USERNAME) {
        clearName = PHONE;
    } else if (fieldName === J_PASSWORD) {
        clearName = PASSWORD;
    } else if (fieldName === J_CAPTCHA) {
        clearName = CAPTCHA;
    }
    return clearName;
};

const form = (state = {}, action = {}) => {
    let mergeState;
    if (action.type === SET_FIELD_ERROR) {
        if (state[action.formName] && state[action.formName].fields[action.fieldName]) {
            const error = typeof action.error === 'string' ? { body: action.error, code: -1 } : action.error;
            mergeState = update(state, {
                [action.formName]: {
                    fields: {
                        [action.fieldName]: {
                            isError: { $set: true },
                            errorMessage: { $set: error?.body },
                            errorCode: { $set: error?.code },
                        },
                    },
                },
            });
        } else {
            mergeState = state;
        }
    } else if (action.type === REMOVE_FIELD_ERROR) {
        if (state[action.formName] && state[action.formName].fields[action.fieldName]) {
            mergeState = update(state, {
                [action.formName]: {
                    fields: {
                        [action.fieldName]: {
                            isError: { $set: false },
                            errorMessage: { $set: '' },
                            errorCode: { $set: 0 },
                        },
                    },
                },
            });
        } else {
            mergeState = state;
        }
    } else if (action.type === SET_NEW_FORM) {
        const newFields = { ...action.fields };
        const oldFields = { ...state[action.formName]?.fields };
        if (action.visibleFields) {
            action.visibleFields.forEach((f) => {
                const newField = newFields[f.name];
                const oldField = oldFields[f.name];
                if (newField && oldField) {
                    newField.value = oldField.value;
                }
            });
        }
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    fields: { $set: newFields },
                    name: { $set: action.formName },
                    action: { $set: action.action },
                },
            },
        });
    } else if (action.type === SET_NEW_FIELDS) {
        const oldFields = { ...state[action.formName].fields };
        const newFields = { ...action.fields };
        Object.keys(newFields).forEach((key) => {
            const oldField = oldFields[key];
            const newField = newFields[key];
            if (isObject(oldField) && oldField.type === newField.type) {
                if (key.startsWith('toValues') || (newField.useCanonical && newField.visible)) {
                    newField.value = oldField.value;
                } else {
                    newField.isReadOnly = oldField.isReadOnly;
                }
                if (oldField.isError) {
                    newField.isError = oldField.isError;
                }
            }
        });
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    fields: { $set: newFields },
                },
            },
        });
    } else if (action.type === REPLACE_FORM_FIELDS) {
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    fields: { $set: { ...action.fields } },
                },
            },
        });
    } else if (action.type === UPDATE_FIELDS) {
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    fields: { $merge: action.fields },
                },
            },
        });
    } else if (action.type === UPDATE_FIELD_VALUES) {
        mergeState = { ...state };
        Object.keys(action.fields).forEach((key) => {
            if (state[action.formName].fields[key]) {
                mergeState = update(mergeState, {
                    [action.formName]: {
                        $auto: {
                            fields: {
                                [key]: {
                                    value: { $set: action.fields[key] },
                                },
                            },
                        },
                    },
                });
            }
        });
    } else if (action.type === ADD_NEW_FIELDS) {
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    fields: { $merge: action.fields },
                },
            },
        });
    } else if (action.type === CHANGE_FIELD_VALUE) {
        mergeState = update(state, {
            [action.formName]: {
                fields: {
                    $auto: {
                        [action.fieldName]: {
                            $auto: {
                                value: { $set: action.value },
                                name: { $set: action.fieldName },
                            },
                        },
                    },
                },
            },
        });
    } else if (action.type === CHANGE_FIELD_PROPERTY) {
        mergeState = update(state, {
            [action.formName]: {
                fields: {
                    $auto: {
                        [action.fieldName]: {
                            $auto: {
                                [action.property]: { $set: action.newValue },
                            },
                        },
                    },
                },
            },
        });
    } else if (action.type === CHANGE_FIELD) {
        mergeState = update(state, {
            [action.formName]: {
                fields: {
                    [clearFieldNameForLoginPage(action.field.name)]: { $merge: action.field },
                },
            },
        });
    } else if (action.type === CHANGE_STATE) {
        mergeState = update(state, {
            state: { $set: action.state },
        });
    } else if (action.type === UPDATE_FORM_PROPERTY) {
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    action: { $set: action.action },
                    validateForm: { $set: action.isValidate },
                },
            },
        });
    } else if (action.type === REMOVE_FIELD) {
        mergeState = update(state, {
            [action.formName]: {
                fields: { $unset: action.fieldNames },
            },
        });
    } else if (action.type === SCROLL_TO_FIELD) {
        mergeState = update(state, {
            [action.formName]: {
                $auto: {
                    scrollToField: { $set: action.fieldName },
                },
            },
        });
    } else if (action.type === DELETE_FORM) {
        if (state[action.formName]) {
            mergeState = update(state, { $unset: [action.formName] });
        } else {
            mergeState = state;
        }
    } else if (action.type === SET_FIELD_VISIBLE) {
        mergeState = update(state, {
            [action.formName]: {
                fields: {
                    [action.fieldName]: {
                        $auto: {
                            visible: { $set: action.visible },
                        },
                    },
                },
            },
        });
    } else {
        return state;
    }
    return mergeState;
};
export default form;
